// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC0RvcFcwg7UTl03XU0GQdoGavf736zL8c",
  authDomain: "jqguitaracademy.firebaseapp.com",
  projectId: "jqguitaracademy",
  storageBucket: "jqguitaracademy.firebasestorage.app",
  messagingSenderId: "307384572851",
  appId: "1:307384572851:web:a03199bcadcc157f16c9c6",
  measurementId: "G-3K5F067B49"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const analytics = getAnalytics(app);

export { auth };